import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, LogOut } from "lucide-react";
import { ProgressWidgets } from "../../components/ProgressWidgets";
import { useAthleteAuth } from "../../lib/athleteAuth";
import { athleteGetProgress } from "../../lib/api";
import AthleteNav from "../../components/athlete/AthleteNav";

/* ------------------------------------------------------------------ page */
export default function AthleteProgressPage() {
  const { athlete, loading, logout } = useAthleteAuth();
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!loading && !athlete) navigate("/athlete/login");
  }, [loading, athlete, navigate]);
  useEffect(() => {
    if (!athlete) return;
    athleteGetProgress().then(setData).catch(() => setErr("Couldn't load your progress right now."));
  }, [athlete]);

  if (loading || !athlete) return <div className="min-h-screen flex items-center justify-center text-[var(--tir-muted)]">Loading…</div>;
  const today = data?.today || new Date().toISOString().slice(0, 10);

  return (
    <div className="min-h-screen bg-[var(--tir-ivory)] pb-24 md:pb-10" data-testid="athlete-progress-page">
      <header className="border-b border-[var(--tir-border)] bg-white">
        <div className="max-w-3xl mx-auto px-5 lg:px-8 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <button type="button" onClick={() => navigate("/athlete/home")} className="text-[var(--tir-muted)] hover:text-[var(--tir-navy)]" aria-label="Back to home" data-testid="athlete-progress-back"><ArrowLeft size={16} /></button>
            <div>
              <div className="text-[10px] tracking-[0.28em] uppercase font-semibold text-[var(--tir-navy)]">Athlete portal</div>
              <h1 className="font-serif-display text-3xl leading-none">Progress</h1>
            </div>
          </div>
          <button type="button" onClick={logout} className="inline-flex items-center gap-1.5 text-[10px] tracking-[0.22em] uppercase text-[var(--tir-muted)] hover:text-[var(--tir-ink)]" data-testid="athlete-progress-signout"><LogOut size={13} /> Sign out</button>
        </div>
      </header>
      <AthleteNav />
      <main className="max-w-3xl mx-auto px-4 lg:px-8 py-6 space-y-5">
        {err && <p className="text-sm text-[var(--tir-burgundy)]" data-testid="progress-error">{err}</p>}
        {!data && !err && <p className="text-sm text-[var(--tir-muted)]" data-testid="progress-loading">Loading your progress…</p>}
        {data && (
          <>
            <ProgressWidgets data={data} today={today} />
          </>
        )}
      </main>
    </div>
  );
}
